/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { CircularProgress } from '@material-ui/core';
import { toast, ToastContainer } from "react-toastify";

import { i18n } from '../../../translate/i18n';

import { putRequest } from 'utils/request';

// import { Container } from './styles';

function ChangePassword() {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [token, setToken] = useState();
  const location = useLocation();
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(password.length >= 5 && password === confirmPassword) {
      setLoading(true);
      await putRequest('/authentications/admin/changepasswordbytoken', {
        token,
        password
      }).then(function() {
        setTimeout(() => {
          history.push('/')
        }, 3100)
      })
      setLoading(false);
    } else {
      toast.error(password.length < 4 ? i18n.t('minimumPassword') : i18n.t('passwordNotMatch'));
    }
  }

  useEffect(() => {
    setToken(location.search.replace('?token=', ''))
  }, [])

  return (
    <div className="bg-login-page">
    <ToastContainer autoClose={3000}/>
      <div className="container-login">
      <div className="login-content first-content ">
        <div className="first-column-login">
        <h2 className="title">{i18n.t('welcomeHeader')}</h2>
        <div className="logo">
            <img
            className="img-logo"
            src="assets/images/logo-omni.png"
            alt="logo"
            />
        </div>
        </div>

        <div className="second-column-login">
        <h1 className="title-login">{i18n.t('changePassword')}</h1>
        <form className="form-login">
          <div className="input-form-login">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder={i18n.t('password2')}
              autocomplete="off"
              required
              value={password}
              onChange={(value) => setPassword(value.target.value)}
            />
              <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                onClick={() => setShowPassword(!showPassword)}
                style={{position: 'absolute', right: '13.5%', top: '35.7%'}}></i>

          </div>
          <div className="input-form-login">
            <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder={i18n.t('confirmPassword')}
                required
                autocomplete="off"
                value={confirmPassword}
                onChange={(value) => setConfirmPassword(value.target.value)}
              />
              <i className={showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{position: 'absolute', right: '13.5%', top: '51.3%'}}></i>
          </div>
          <div className="box-btn-login" style={{marginTop: 50}}>
            <>
              {!loading ? (
              <button 
                  type="submit"
                  className="btn-login" 
                  onClick={handleSubmit}
              >
              {i18n.t('send')}
              </button>
              ) : (
              <div className="area-loading-login">
                  <CircularProgress />
              </div>
              )}
            </>
          </div>
        </form>
        </div>
      </div>
      </div>
    </div>
  );
}

export default ChangePassword;